import { Mark } from '@tiptap/core'

/**
 * FontColor extension for TipTap
 * Allows setting font color on selected text via inline styles
 */
export const FontColor = Mark.create({
    name: 'fontColor',
    addOptions() {
        return {
            types: ['textStyle'],
        }
    },
    addAttributes() {
        return {
            color: {
                default: null,
                parseHTML: element => {
                    return element.style.color || null
                },
                renderHTML: attributes => {
                    if (!attributes.color) {
                        return {}
                    }
                    return {
                        style: `color: ${attributes.color}`,
                    }
                },
            },
        }
    },
    parseHTML() {
        return [
            {
                tag: 'span[style*="color"]',
                getAttrs: element => {
                    const color = element.style.color
                    return color ? { color } : null
                },
            },
        ]
    },
    renderHTML({ HTMLAttributes }) {
        return ['span', HTMLAttributes, 0]
    },
    addCommands() {
        return {
            setColor: (color) => ({ chain }) => {
                return chain()
                    .setMark(this.name, { color })
                    .run()
            },
            unsetColor: () => ({ chain }) => {
                return chain()
                    .unsetMark(this.name)
                    .run()
            },
        }
    },
})
